/**
 * debug.js
 *
 * Debug utilities for mvplan using the debug library.
 *
 * Usage in browser console:
 *   localStorage.debug = 'mvplan:*'           // Enable all
 *   localStorage.debug = 'mvplan:buhlmann'    // Enable specific namespace
 *   localStorage.debug = 'mvplan:planner,mvplan:gas'  // Multiple namespaces
 *   localStorage.debug = ''                   // Disable all
 *
 * Then refresh the page.
 */

import createDebug from 'debug'

// Main namespaces
export const debugBuhlmann = createDebug('mvplan:buhlmann')
export const debugPlanner = createDebug('mvplan:planner')
export const debugGas = createDebug('mvplan:gas')
export const debugStore = createDebug('mvplan:store')
export const debugCCR = createDebug('mvplan:ccr')
export const debugSavedPlans = createDebug('mvplan:savedplans')
export const debugPdfExport = createDebug('mvplan:pdf')

// Sub-namespaces for more granular control
export const debugBuhlmannTissues = createDebug('mvplan:buhlmann:tissues')
export const debugBuhlmannCeiling = createDebug('mvplan:buhlmann:ceiling')
export const debugPlannerDeco = createDebug('mvplan:planner:deco')
export const debugPlannerSegments = createDebug('mvplan:planner:segments')

// Helper to enable debug in browser programmatically
export function enableDebug(namespaces = 'mvplan:*') {
  if (typeof localStorage !== 'undefined') {
    localStorage.debug = namespaces
    console.log(`Debug enabled for: ${namespaces}`)
    console.log('Refresh the page to see debug output')
  }
}

// Helper to disable debug
export function disableDebug() {
  if (typeof localStorage !== 'undefined') {
    localStorage.debug = ''
    console.log('Debug disabled. Refresh the page.')
  }
}

// Expose helpers globally for easy console access
if (typeof window !== 'undefined') {
  window.mvplanDebug = {
    enable: enableDebug,
    disable: disableDebug,
    namespaces: [
      'mvplan:*',
      'mvplan:buhlmann',
      'mvplan:buhlmann:tissues',
      'mvplan:buhlmann:ceiling',
      'mvplan:planner',
      'mvplan:planner:deco',
      'mvplan:planner:segments',
      'mvplan:gas',
      'mvplan:store',
      'mvplan:ccr',
      'mvplan:savedplans',
      'mvplan:pdf'
    ]
  }
}
